import * as React from 'react';
import * as moment from "moment";
import {Button, Col, Row, Select, Switch} from 'antd';
import locales from "../../locales";
import MonthName from "./MonthName";
import {DateRange} from "../../common/dtos";
import {MOMENT_DATE_FORMAT, toEndOfWeek, toStartOfWeek} from "../../utils/date-utils";
import {User} from "../../api/dtos/dtos";
import accountProvider from "../../account/AccountProvider";

export interface CalendarHeaderProps {
    salesUsers: User[];
    salesUser?: string;
    onSalesUserChange: (userName: string) => void;
    dateRange: DateRange;
    onDateRangeChange: (dateRange: DateRange) => void;
    onAddEventClick: () => void;
    onShowTodosChange: (showTodos: boolean) => void;
    showTodos: boolean;
}

class CalendarHeader extends React.Component<CalendarHeaderProps, {}> {
    public render(): React.ReactNode {
        const {dateRange, salesUsers, salesUser, onSalesUserChange, onAddEventClick, onShowTodosChange, showTodos} = this.props;
        const today = moment().format(MOMENT_DATE_FORMAT);

        return (
            <Row className="calendar-header" gutter={16}>
                <Col
                    className="month-name"
                    xs={24}
                    md={8}
                >
                    <MonthName dateRange={dateRange}/>
                    <Button
                      style={{marginLeft: 8}}
                      size="small"
                      title={today}
                      onClick={this.onTodayClick}
                    >
                        {locales.today}
                    </Button>
                    <Button
                      style={{marginLeft: 8}}
                      size="small"
                      icon="left"
                      title={locales.event_show_previous_week}
                      onClick={this.onPreviousClick}
                    />
                    <Button
                      style={{marginLeft: 8}}
                      size="small"
                      icon="right"
                      title={locales.event_show_next_week}
                      onClick={this.onNextClick}
                    />
                </Col>
                <Col
                    className="controls"
                    xs={24}
                    md={8}
                >
                    {accountProvider.isAdmin() &&
                        <Select
                            className="mild-disabled sales-selector"
                            size="small"
                            allowClear={false}
                            disabled={salesUsers.length < 2}
                            placeholder={locales.choose}
                            value={salesUser}
                            onChange={onSalesUserChange}
                        >
                            {salesUsers && salesUsers.map(this.renderUser)}
                        </Select>
                    }
                    <Switch
                        style={{marginLeft: 16, marginRight: 6}}
                        defaultChecked={showTodos}
                        onChange={onShowTodosChange}
                        title={locales.event_show_todos}
                    />
                    <span className="todo">{locales.event_show_todos}</span>
                </Col>
                <Col
                    className="add-event"
                    xs={24}
                    md={8}
                >
                    <Button
                        size="small"
                        type="primary"
                        icon="plus"
                        onClick={onAddEventClick}
                    >
                        {locales.event_create}
                    </Button>
                </Col>
            </Row>
        );
    };

    private renderUser = (u: User): React.ReactNode => {
        return (
            <Select.Option
                key={u.userName}
                value={u.userName}
                title={u.userName}
            >
                {u.userName}
            </Select.Option>
        )
    }

    private onTodayClick = () => {
        const now = moment();
        const thisWeek: DateRange = {
            start: toStartOfWeek(now),
            end: toEndOfWeek(now),
        };
        this.props.onDateRangeChange(thisWeek);
    }

    private onPreviousClick = () => {
        const {start, end} = this.props.dateRange;
        const previousWeek: DateRange = {
            start: toStartOfWeek(start.clone().subtract(1, 'week')),
            end: toEndOfWeek(end.clone().subtract(1, 'week')),
        }
        this.props.onDateRangeChange(previousWeek);
    }

    private onNextClick = () => {
        const {start, end} = this.props.dateRange;
        const nextWeek: DateRange = {
            start: toStartOfWeek(start.clone().add(1, 'week')),
            end: toEndOfWeek(end.clone().add(1, 'week')),
        }
        this.props.onDateRangeChange(nextWeek);
    }
}

export default CalendarHeader;


// WEBPACK FOOTER //
// ./src/event/header/CalendarHeader.tsx